export default __webpack_public_path__ + "static/media/logo_esle.0d34fad2.png";